// extracted by mini-css-extract-plugin
export default {"maincontainer":"Logout_maincontainer__yORFu","deletecard":"Logout_deletecard__2SxmF"};